__webpack_require__.p = "https://euapp.baduconnect.com/";